import React, {useState, useEffect} from 'react';
import Formulario from './components/Formulario';
import Clima from './components/Clima';
import Error from './components/Error';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {

  // useState para leer los datos:
  const [busqueda, guardarBusqueda] = useState({
    ciudad: '',
    pais: ''
  });

  const { ciudad, pais } = busqueda;

  const [consultar, guardarConsultar] = useState(false);

  const [resultado, guardarResultado] = useState({});

  const [error, guardarError] = useState(false);

  // consultar la API:
  useEffect( () => {
    const consultarApi = async () =>{
      if(consultar){
        const apiId = 'eaeceed1f4968a8cd215b5c5c78775ee';
        const url = `https://api.openweathermap.org/data/2.5/weather?q=${ciudad},${pais}&appid=${apiId}`;
        const respuesta = await fetch(url);
        const resultado = await respuesta.json();

        guardarResultado(resultado);
        guardarConsultar(false);

        if(resultado.cod === '404'){
          guardarError(true);
        } else{
          guardarError(false);
        }
      }
    }
    consultarApi();
  }, [consultar, ciudad, pais])

  let componente;
  if(error){
    componente = <Error  mensaje='No se encontrado resultados'/>
  }else{
    componente=<Clima 
    resultado={resultado}
  />
  }

  return (
    <div className='fondo'>
      <div className='row'>
        <div className='col-md-6 formulario d-flex align-items-center justify-content-center'>
          <Formulario 
            busqueda = {busqueda}
            guardarBusqueda = {guardarBusqueda}
            guardarConsultar={guardarConsultar}
          />
        </div>
        <div className='col-md-6 vista_clima d-flex align-items-center justify-content-center'>
          {componente}
        </div>
      </div>
    </div>
  );
}

export default App;
